import { Sizer } from "phaser3-rex-plugins/templates/ui/ui-components";
import { TEXT_STYLES } from "../../utils/FontManager";
import Game from "../game/Game";
import Scenes from "../enums/Scenes";
import { t } from "../../utils/i18n/index";
import { DEFAULT_SCALE } from "../consts/UI";

export default class PauseScene extends Phaser.Scene {
  private panel: Sizer;
  private scaleRatio: number;

  constructor() {
    super({ key: Scenes.PauseScene });
  }

  create() {
    this.scaleRatio = DEFAULT_SCALE;
    const width = 300 * this.scaleRatio;
    const height = 400 * this.scaleRatio;

    // Create semi-transparent background
    const bg = this.add.rectangle(
      0,
      0,
      this.scale.width,
      this.scale.height,
      0x000000,
      0.7
    );
    bg.setOrigin(0);

    this.panel = this.rexUI.add
      .sizer({
        x: this.scale.width / 2,
        y: this.scale.height / 2,
        width: width,
        height: height,
        orientation: "vertical",
      })
      .add(
        this.add.text(0, 0, t("common.pause"), {
          ...TEXT_STYLES.PIXEL,
          fontSize: `${32 * this.scaleRatio}px`,
          color: "#ffffff",
        }),
        { padding: { bottom: 40 * this.scaleRatio } }
      );

    // Continue button
    const continueButton = this.createButton(t("common.continue"), 0x4caf50);
    continueButton.onClick(() => {
      Game.Core.SceneManager.ResumeFromPause();
    });

    // Finish run button
    const finishButton = this.createButton(t("common.quit"), 0xff5252);
    finishButton.onClick(() => {
      // Kill the player which will trigger the natural game over sequence
      //Game.Core.Player.isDead = true
      //Game.Core.Player.Body.enable = false
      Game.Core.GameOver();
      this.scene.stop();
    });

    this.panel
      .add(continueButton, { padding: { bottom: 20 * this.scaleRatio } })
      .add(finishButton)
      .layout();
  }

  private createButton(text: string, color: number) {
    const width = 200 * this.scaleRatio;
    const height = 50 * this.scaleRatio;

    const background = this.rexUI.add.roundRectangle(
      0,
      0,
      width,
      height,
      10 * this.scaleRatio,
      color
    );

    return this.rexUI.add
      .label({
        background,
        text: this.add.text(0, 0, text, {
          ...TEXT_STYLES.REGULAR,
          fontSize: `${16 * this.scaleRatio}px`,
          color: "#FFFFFF",
        }),
        space: { left: 0, right: 0, top: 0, bottom: 0 },
        align: "center",
        width: width,
        height: height,
      })
      .setInteractive({ cursor: "pointer" });
  }
}
